import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InvoicesTableEndActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S12};
  margin-left: auto;
`

// Receives the table's columns filtering through a portal, see `showColumnsFilteringInActions`.
export const InvoicesTableColumnsFilteringContainer = styled.div`
  display: flex;
  align-items: center;
`
